import { useCallback } from 'react';
import { useSendCoiCheckEmailMessageMutation } from 'store/api/emails';
import { CoiCheckEmailData, CoiCheckEmailForm } from 'types/coi-check';
import { splitMultilineHtmlText } from 'utils/emails';
import { t } from 'utils/getTranslations';
import useAuth from './useAuth.ts';

export const formatDate = (inputDate: Date) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

export const useCoiCheckEmailSend = () => {
    const { user: currentUser } = useAuth();
    const [sendCoiCheckEmailMessage] = useSendCoiCheckEmailMessageMutation();

    return useCallback(
        async (formData: CoiCheckEmailForm, coiCheckEmailData: CoiCheckEmailData[]) => {
            const content = buildHtmlContent(formData, currentUser?.name ?? null, coiCheckEmailData);
            const emailForm = {
                ids: coiCheckEmailData.map((data) => `${data.id}`),
                to: formData.employees.map((employee) => `${employee.id}`),
                replyTo: formData.replyTo,
                subject: t('coi.send-email.subject'),
                content: content,
            };
            await sendCoiCheckEmailMessage(emailForm);
        },
        [currentUser?.name, sendCoiCheckEmailMessage]
    );
};

function buildHtmlContent(
    formData: CoiCheckEmailForm,
    userName: string | null,
    coiCheckEmailData: CoiCheckEmailData[]
): string {
    const currentDomain = `${window.location.protocol}//${window.location.host}`;
    const sender = userName ? `<p>${t('coi.send-email.sent-by')} ${userName} ${t('coi.send-email.source')}</p>` : '';
    const message = formData.additionalContent ? `${splitMultilineHtmlText(formData.additionalContent)}<br/>` : '';
    const coiCheckData = coiCheckEmailData
        .map((item) => {
            return `<p><strong>${t('coi.send-email.search-date')}</strong>: ${formatDate(item.checkedAt)}</p>
<p><strong>${t('coi.send-email.keyword')}</strong>: ${item.searchTerm}</p>
<p><a href="${currentDomain + '/coi-check/' + item.id}">${t('coi.send-email.link')}</a></p>
<br/>`;
        })
        .join('\r\n');
    return `<html>
<body>
${message}
${coiCheckData}
${sender}
<br/>
</body>
</html>`;
}
